import { defineComponent as _defineComponent } from 'vue'
import GratitudesJournalCelebrations from './GratitudesJournalCelebrations.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GratitudesJournalMessageCard',
  props: {
    message: null,
    hasBadge: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: "close"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	message: string,
	hasBadge: boolean,
}





const close = () => {
	emit("close")
}

return { __sfc: true,props, emit, close, GratitudesJournalCelebrations }
}

})